import { Injectable, PLATFORM_ID, inject, signal } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class NanobarService {
  private readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  readonly progress = signal(0);
  readonly visible = signal(false);

  private pending = 0;
  private trickleTimer?: ReturnType<typeof setInterval>;
  private hideTimer?: ReturnType<typeof setTimeout>;

  start(): void {
    if (!this.isBrowser) return;
    this.pending++;
    if (this.pending === 1) this.begin();
  }

  complete(): void {
    if (!this.isBrowser) return;
    this.pending = Math.max(0, this.pending - 1);
    if (this.pending === 0) this.finish();
  }

  private begin(): void {
    clearTimeout(this.hideTimer);
    clearInterval(this.trickleTimer);

    this.visible.set(true);
    // Jump to a small initial value so the user sees immediate feedback
    this.progress.set(Math.max(this.progress(), 0.08));

    // Keep creeping forward; slows down as it approaches the end, never reaches it
    this.trickleTimer = setInterval(() => this.trickle(), 300);
  }

  private trickle(): void {
    const p = this.progress();
    const step =
      p < 0.2 ? 0.1 :
        p < 0.5 ? 0.04 :
          p < 0.8 ? 0.02 :
            p < 0.99 ? 0.005 : 0;
    this.progress.set(Math.min(p + step, 0.994));
  }

  private finish(): void {
    clearInterval(this.trickleTimer);
    this.progress.set(1);

    // Let the nanobar reach 100%, fade out, then reset invisibly
    this.hideTimer = setTimeout(() => {
      this.visible.set(false);
      this.hideTimer = setTimeout(() => this.progress.set(0), 300);
    }, 250);
  }
}
